<template>
    <v-form ref="form" @submit.prevent="submit" v-model="valid">
        <FormExpansion :value="guest ? null : 0" :readonly="!guest">
            <template #question> Your information </template>
            <template #response>
                <div class="flex flex-col gap-4 pa-4">
                    <div
                        class="flex justify-between gap-4"
                        :class="{ 'flex-col ': $vuetify.breakpoint.xs }"
                    >
                        <SoliText
                            v-model="form.first_name"
                            icon="person"
                            label="Your First Name"
                            :rules="[
                                (v) => !!v || 'Your first name is required',
                            ]"
                            hideDetails="auto"
                            :error="errors.first_name"
                        />
                        <SoliText
                            v-model="form.last_name"
                            icon="people"
                            label="Your Last Name"
                            :rules="[
                                (v) => !!v || 'Your last name is required',
                            ]"
                            hideDetails="auto"
                            :error="errors.last_name"
                        />
                    </div>
                    <BookingEmail
                        hideDetails="auto"
                        v-model="form.email"
                        :error="form.email"
                    />
                    <SoliPhone
                        hideDetails="auto"
                        v-model="form.phone"
                        :error="form.phone"
                    />

                    <div v-if="!guest">
                        <v-divider class="mt-4" />
                        <div
                            class="flex justify-center"
                            style="transform: translateY(-13px)"
                        >
                            <v-sheet class="w-10 white"
                                ><div
                                    class="font-bold soli-grey flex justify-center"
                                >
                                    or
                                </div></v-sheet
                            >
                        </div>
                        <v-btn
                            text
                            color="primary"
                            rounded
                            @click="
                                $inertia.visit(route('login'), {
                                    data: {
                                        successRoute: $page.url,
                                    },
                                })
                            "
                            >I already have an account</v-btn
                        >
                    </div>
                </div>
            </template>
        </FormExpansion>

        <FormItem v-if="false">
            <template #question>Child Information</template>
            <template #action>
                <v-row no-gutters class="gap-2">
                    <div v-if="form.children.length < 3">
                        <v-btn
                            x-small
                            outlined
                            class="soli-round"
                            color="accent"
                            @click="
                                form.children.push({
                                    first_name: null,
                                    last_name: form.last_name,
                                    birthday: null,
                                })
                            "
                            >Add Another Child</v-btn
                        >
                    </div>
                    <div v-if="form.children.length > 1">
                        <v-btn
                            x-small
                            outlined
                            class="soli-round"
                            color="error"
                            @click="form.children.splice(-1)"
                            >Remove Last Child</v-btn
                        >
                    </div></v-row
                >
            </template>
            <template #response>
                <div
                    class="flex flex-col gap-4"
                    :class="{ 'mb-4': idx + 1 !== form.children.length }"
                    v-for="(child, idx) of form.children.length"
                    :key="child[idx]"
                >
                    <div
                        class="flex justify-between gap-4"
                        :class="{ 'flex-col ': $vuetify.breakpoint.xs }"
                    >
                        <SoliText
                            v-model="form.child_first_name"
                            icon="person"
                            label="Child's First Name"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    `Your child's first name is required`,
                            ]"
                            hideDetails="auto"
                            :error="errors.child_first_name"
                        />
                        <SoliText
                            v-model="form.child_last_name"
                            icon="people"
                            label="Child's Last Name"
                            :rules="[
                                (v) =>
                                    !!v || `Your child's last name is required`,
                            ]"
                            hideDetails="auto"
                            :error="errors.child_last_name"
                        />
                    </div>
                    <SoliBirthday
                        v-model="form.child_birthday"
                        label="Child's Birthday"
                        required
                        hideDetails="auto"
                    ></SoliBirthday>
                    <v-divider v-if="idx + 1 !== form.children.length" />
                </div>
            </template>
        </FormItem>

        <FormSubmit
            v-if="!guest"
            dark
            type="submit"
            :loading="loading"
            valid
            :errors="errors"
            gradient="gradient-orange"
            icon="send"
            text="Continue"
        />
    </v-form>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment";
import FormRules from "../../Mixins/FormRules";
import FormItem from "../Form/FormItem.vue";
import FormExpansion from "../Form/FormExpansion.vue";
import FormTitle from "../Form/FormTitle.vue";
import FormSubmit from "../Form/FormSubmit.vue";
import BookingEmail from "../Booking/BookingEmail.vue";
import BookingSimpleSelect from "../Booking/BookingSimpleSelect.vue";

export default {
    mixins: [globalMoment, FormRules],
    components: {
        FormTitle,
        FormItem,
        FormExpansion,
        FormSubmit,
        BookingEmail,
        BookingSimpleSelect,
    },
    props: {
        errors: {},
        location: {
            type: Object,
            default: () => {},
        },
        eventRegister: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
    },
    remember: {
        data: ["form"],
        key: "EventRegistration/EventRegistrationCreate",
    },
    data() {
        return {
            form: this.$inertia.form({
                location_id: this.location.id,
                first_name: this.guest?.first_name,
                last_name: this.guest?.last_name,
                email: this.guest?.email,
                phone: this.guest?.phone,
                program_id: this.eventRegister?.program?.id,
                //program_name: this.eventRegister?.program.title,
                has_child: false,
                contact_only: false,
                online: false,
                virtual_client: this.guest?.virtual_client ?? false,
                //promo: null,
                //source: null,
                /*event_register_id: null,
                student_id: null,
                user: this.user?.id ?? null,
                children: [
                    {
                        first_name: null,
                        last_name: null,
                        birthday: null,
                    },
                ],*/
            }),
            loading: false,
            valid: false,
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(() => {
                    const el = document.querySelector(
                        ".v-messages.error--text"
                    );
                    el.scrollIntoView({ block: "center" });
                });

                return;
            }
            this.loading = true;

            this.form.post(route("guestSession.store"), {
                preserveState: (page) => Object.keys(page.props.errors).length,
                preserveScroll: true,
                onSuccess: () => {
                    this.loading = false;
                    this.$emit("success");
                },
                onError: (errors) => {
                    this.loading = false;
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    if (errors.contactSupport) return;
                    if (errors.soliError) return;
                },
            });
        },
        reset() {
            this.$refs.form.reset();
        },
    },
    watch: {
        "form.location": function (val) {
            this.$inertia.reload({ preserveState: true });
        },
        form: {
            handler: function (val) {
                if (val.phone?.length < 12 && this.valid) {
                    this.$refs.form.validate();
                }
                if (!val.child_birthday && this.form.has_child && this.valid) {
                    this.$refs.form.validate();
                }
                if (val) {
                    this.$emit("input", val);
                }
            },
            deep: true,
        },
    },
};
</script>
